import React from "react";
import { Navigation, Phone } from "lucide-react";
import { BUSINESS } from "../data";

export const MobileCTABar = () => (
  <div
    data-testid="mobile-cta-bar"
    className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-black/80 backdrop-blur-2xl border-t border-white/10 px-4 py-3 flex gap-3"
  >
    <a
      href={BUSINESS.callLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-cta-call"
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-white/20 text-white font-semibold py-3 text-sm hover:border-neon hover:text-neon transition-colors duration-300"
    >
      <Phone size={16} /> Call
    </a>
    <a
      href={BUSINESS.directions}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-cta-directions"
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-neon text-black font-semibold py-3 text-sm"
    >
      <Navigation size={16} /> Directions
    </a>
  </div>
);
